import { I18n } from 'react-i18nify'

export const setTranslation = translation => {
  I18n.setTranslations({
    default: translation
  })

  I18n.setLocale('default')
}



// WEBPACK FOOTER //
// ./src/services/Translation/Translation.js